
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {},
  name: 'HealthCheck',
})
export default class HealthCheck extends Vue {
  private status = 'Ok';
}
